import request from '@/utils/request'

export const pageListApi = (data) => {
  return request({
    url: 'AnnualLeave/adminBalanceList',
    method: 'post',
    data
  })
}

export const saveApi = (data) => {
  return request({
    url: 'AnnualLeave/adminSaveBalance',
    method: 'post',
    data
  })
}
